mutation UpdateInternalExpense($id: ID!, $input: UpdateInternalExpenseInput!) {
  updateInternalExpense(id: $id, input: $input) {
    id
  }
}
